var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mute-btn thinly-shadowed",class:{ tutorial: _vm.showTutorial },on:{"click":_vm.showHelp}},[(_vm.userMuted)?_c('img',{staticClass:"mic-img",attrs:{"src":require("@/assets/img/utils/mic_muted.svg")}}):_c('img',{staticClass:"mic-img",attrs:{"src":require("@/assets/img/utils/mic_open.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }